import { createContext } from "react";

export const HighRiskContext = createContext<any>({});
